import { render, staticRenderFns } from "./ConfirmMoveAsset.vue?vue&type=template&id=651ee230&scoped=true&"
import script from "./ConfirmMoveAsset.vue?vue&type=script&lang=ts&"
export * from "./ConfirmMoveAsset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ee230",
  null
  
)

export default component.exports